export default function ListItemButton(theme) {
    return {
        MuiListItemButton: {
            variants: [
                {
                    props: { variant: 'sidebar-button' },
                    style: {
                        display: 'inline-flex',
                        flexDirection: 'column',
                        paddingLeft: theme.spacing(2),
                        paddingRight: theme.spacing(2),
                        paddingTop: 8,
                        paddingBottom: 0,
                        borderRadius: theme.shape.borderRadius,

                        '&.MuiListItemButton-gutters': {
                            display: 'inline-flex',
                            paddingLeft: theme.spacing(2),
                            paddingRight: theme.spacing(2),
                        },

                        '&.Mui-selected': {
                            // backgroundColor: theme.palette.action.selected,
                            color: theme.palette.primary.main,
                        },

                        '&:hover': {
                            backgroundColor: theme.palette.action.hover,
                        },
                    },
                },
            ],
        },
    };
}
